var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPPlannedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.99988C0 15.5227 4.47715 19.9999 10 19.9999C15.5228 19.9999 20 15.5227 20 9.99988C20 4.47703 15.5228 -0.00012207 10 -0.00012207C4.47715 -0.00012207 0 4.47703 0 9.99988ZM18 9.99988C18 14.4182 14.4183 17.9999 10 17.9999C5.58172 17.9999 2 14.4182 2 9.99988C2 5.5816 5.58172 1.99988 10 1.99988C14.4183 1.99988 18 5.5816 18 9.99988ZM10 9.99988V3.99988C11.6569 3.99988 13.1569 4.67145 14.2426 5.75724L10 9.99988Z",
    fill: "#375DFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPPlannedIcon);
export default __webpack_public_path__ + "static/media/p-planned-icon.a800c34d512c587a08f39895ca4fda47.svg";
export { ForwardRef as ReactComponent };